(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["additional-information"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-section-id]").forEach((section) => {
      const accordion = section.querySelector(".additional-information .accordion details");
      if (!accordion) return;

      const mediaQuery = window.matchMedia("(min-width: 750px)");

      const toggleAccordion = () => {
        // if (mediaQuery.matches) {
        //   accordion.setAttribute("open", "true");
        // } else {
        //   // accordion.removeAttribute("open");
        // }
      };

      toggleAccordion();
      mediaQuery.addEventListener("change", toggleAccordion);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advice-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var flkty = new Flickity('.advice-slider__carousel', {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: false,
      draggable: true,
      prevNextButtons: false,
      percentPosition: true,
    });

    const element = document.querySelector('.advice-slider');
    const desktopCols = parseInt(getComputedStyle(element).getPropertyValue('--columns'));
    const mobileCols = parseInt(getComputedStyle(element).getPropertyValue('--columns-mobile'));

    var dotsContainer = document.createElement('ul');
    dotsContainer.className = 'flickity-page-dots';
    document.querySelector('.advice-slider__carousel').after(dotsContainer);

    function updateSlidesPerView() {
      var isMobile = window.innerWidth < 769;
      var cols = isMobile ? mobileCols : desktopCols;
      var gap = isMobile ? 12 : 30;
      var showOneAndHalf = element.getAttribute('data-show-one-and-half') === 'true';

      let totalSlides = flkty.cells.length;
      let effectiveCols = totalSlides < cols ? totalSlides : cols;
      
      // For mobile, show 1.5 images if setting is enabled, otherwise use regular columns
      var width;
      if (isMobile && showOneAndHalf) {
        width = `calc(${100 / 1.5}% - ${gap / 1.5}px)`;
      } else {
        width = `calc(${25}% - ${gap}px)`;
      }

      document.querySelectorAll('.advice-slider__card').forEach((card) => {
        card.style.width = width;
      });

      flkty.reloadCells();
      flkty.resize();

      let currentIndex = flkty.selectedIndex;
      // For mobile, use 1.5 as visible slides if setting enabled; for desktop, use effectiveCols
      let visibleSlides = (isMobile && showOneAndHalf) ? 1.5 : effectiveCols;
      let maxStartIndex = Math.floor(flkty.cells.length - visibleSlides);
      if (maxStartIndex < 0) maxStartIndex = 0;
      if (currentIndex > maxStartIndex) {
        currentIndex = maxStartIndex;
      }
      flkty.select(currentIndex, false, true);

      updateDots(visibleSlides);

      let dots = dotsContainer.querySelectorAll('.dot');
      if (dots[currentIndex]) {
        dots.forEach((d) => d.classList.remove('is-selected'));
        dots[currentIndex].classList.add('is-selected');
      }
    }



    function updateDots(visibleSlides) {
      let totalSlides = flkty.cells.length;
      let isMobile = window.innerWidth < 769;

      // Hide dots on desktop if slides are less than or equal to desktop columns
      if (!isMobile && totalSlides <= desktopCols) {
        dotsContainer.style.display = 'none';
        return;
      } else {
        dotsContainer.style.display = 'flex';
      }

      // For mobile with 1.5 slides visible, show dots if more than 1.5 slides
      if (totalSlides <= visibleSlides) {
        dotsContainer.innerHTML = '';
        return;
      }

      let dotsNeeded = Math.ceil(totalSlides - visibleSlides + 1);
      dotsContainer.innerHTML = '';

      for (let i = 0; i < dotsNeeded; i++) {
        let dot = document.createElement('li');
        dot.classList.add('dot');
        if (i === 0) dot.classList.add('is-selected');
        dot.addEventListener('click', () => {
          flkty.select(i);
        });
        dotsContainer.appendChild(dot);
      }
    }

    flkty.on('change', function (index) {
      let dots = dotsContainer.querySelectorAll('.dot');
      dots.forEach((d, i) => d.classList.toggle('is-selected', i === index));
    });

    updateSlidesPerView();
    window.addEventListener('resize', updateSlidesPerView);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["age-based-collections-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.age-tab').forEach((tab) => {
    tab.addEventListener('click', function () {
      document.querySelectorAll('.age-tab').forEach((btn) => btn.classList.remove('active'));
      document.querySelectorAll('.age-tab-content').forEach((content) => content.classList.remove('active'));

      this.classList.add('active');
      document.querySelector('.age-tab-content[data-tab="' + this.dataset.tab + '"]').classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["baby-registry-form"] && !Shopify.designMode) return;
  try {
    
  function todayISOLocal() {
    const now = new Date();
    const tzOffsetMs = now.getTimezoneOffset() * 60000;
    const local = new Date(now - tzOffsetMs);
    return local.toISOString().split('T')[0];
  }

  function applyDateMaxToEditInputs() {
    const maxDate = todayISOLocal();
    document.querySelectorAll('.edit-age').forEach(inp => {
      inp.setAttribute('max', maxDate);
      if (inp.value && inp.value > maxDate) inp.value = maxDate;
    });
  }

  async function fetchRegistryData(customerId) {
    try {
      const response = await fetch(`/apps/chicco-form/baby-registry?customerId=${customerId}` , {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          "x-api-key": 'e7bb9eb9cf0bf42523c8cc713ca1bfae'
        }
      });
      if (!response.ok) {
        throw new Error('Failed to fetch registry data');
      }
      const responseData = await response.json();
      
      if (responseData.status === 'success' && responseData.data?.metafields?.edges?.length > 0) {
        const childDetailNode = responseData.data.metafields.edges[0].node;
        if (childDetailNode.value) {
          try {
            return JSON.parse(childDetailNode.value);
          } catch (parseError) {
            console.error('Error parsing child details:', parseError);
            return [];
          }
        }
      }
      return [];
    } catch (error) {
      console.error('Error fetching registry data:', error);
      throw error;
    }
  }
 
  function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
 
  function updateRegistryDisplay(entries) {
    const registryEntries = document.getElementById('registryEntries');
    registryEntries.innerHTML = '';

    const todayMaxISO = todayISOLocal();
 
    if (entries && entries.length > 0) {
      entries.forEach((entry, index) => {
        const entryElement = document.createElement('div');
        entryElement.className = 'registry-entry';
        entryElement.dataset.entryIndex = index;
        entryElement.innerHTML = `
          <div class="registry-entry-detail-wrapper">
            <div class="entry-header">
              <h4 class="entry-name">${entry.name}</h4>
            </div>
            <div class="entry-details">
              <span class="entry-age" data-date="${entry.age}">${formatDate(entry.age)}</span>
              <span class="entry-gender">${entry.gender}</span>
            </div>
            <div class="edit-form-popup-overlay">
              <div class="edit-form">
                <h3 class="edit-form-title">Edit Registry Entry</h3>
                <input type="text" class="edit-name" value="${entry.name}" placeholder="Baby's Name">
                <input type="date" class="edit-age"
                  max="${todayMaxISO}"
                  value="${entry.age ? new Date(entry.age).toISOString().split('T')[0] : ''}">
                <div class="gender-options">
                  <label class="radio-label">
                    <input type="radio" name="edit-gender-${index}" value="Boy" ${entry.gender === 'Boy' ? 'checked' : ''}>
                    Boy
                  </label>
                  <label class="radio-label">
                    <input type="radio" name="edit-gender-${index}" value="Girl" ${entry.gender === 'Girl' ? 'checked' : ''}>
                    Girl
                  </label>
                </div>
                <div class="edit-form-buttons">
                  <button type="button" class="button button--secondary cancel-button">Cancel</button>
                  <button type="button" class="button button--primary save-button">Save Changes</button>
                </div>
              </div>
            </div>
          </div>
          <div class="registry-entry-action-wrapper">
            <div class="registry-entry-action-button-item">
              <button class="edit-entry-button">Edit</button>
            </div>
            <div class="registry-entry-action-button-item">
              <button class="delete-entry-button">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.3166 4.90237 5.6834 5.29289 5.29289Z" fill="#0F1729"></path> </g>
                </svg>
              </button>
            </div>
          </div>
        `;
        registryEntries.appendChild(entryElement);
      });

      applyDateMaxToEditInputs();

    } else {
      const noEntriesMessage = document.createElement('p');
      noEntriesMessage.className = 'no-entries';
      noEntriesMessage.textContent = 'No registry entries found.';
      registryEntries.appendChild(noEntriesMessage);
    }
  }
 
  let registryData = [];
 
  async function sendToAPI(data) {
    try {
      const response = await fetch('/apps/chicco-form/baby-registry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "x-api-key": 'e7bb9eb9cf0bf42523c8cc713ca1bfae'
        },
        body: JSON.stringify(data),
      });
 
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
 
      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }
 
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('babyRegistryForm');
    const toggleButton = document.getElementById('toggleRegistry');
    const registryDisplay = document.getElementById('registryDisplay');
    const registryEntries = document.getElementById('registryEntries');
    const customerId = document.querySelector('.section-baby-registry-form').dataset.customerId;

    const birthInput = document.getElementById('babyBirthDate');
    if (birthInput) {
      const maxDate = todayISOLocal();
      birthInput.setAttribute('max', maxDate);
      if (birthInput.value && birthInput.value > maxDate) {
        birthInput.value = maxDate;
      }
    }

    applyDateMaxToEditInputs();
 
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
 
      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton.textContent;
      
      submitButton.disabled = true;
      submitButton.classList.add('button-loading');
 
      const name = document.getElementById('babyName').value.trim();
      const birthDate = document.getElementById('babyBirthDate').value;
      const gender = document.querySelector('input[name="gender"]:checked').value;

      const maxDate = todayISOLocal();
      if (birthDate > maxDate) {
        submitButton.disabled = false;
        submitButton.classList.remove('button-loading');
        submitButton.textContent = originalText;

        const errorMessage = document.createElement('div');
        errorMessage.className = 'form-message form-message--error';
        errorMessage.textContent = 'Birth date cannot be in the future.';
        form.insertBefore(errorMessage, form.firstChild);
        setTimeout(() => errorMessage.remove(), 4000);
        return;
      }
 
      const newEntry = {
        name: name,
        age: birthDate,
        gender: gender.charAt(0).toUpperCase() + gender.slice(1),
      };
 
      registryData.push(newEntry);
 
      try {
        const payload = {
          customerId: customerId,
          childDetails: registryData,
        };
 
        await sendToAPI(payload);
 
        const updatedData = await fetchRegistryData(customerId);
        registryData = updatedData;
        updateRegistryDisplay(registryData);

        applyDateMaxToEditInputs();
 
        form.reset();
 
        const successMessage = document.createElement('div');
        successMessage.className = 'form-message form-message--success';
        successMessage.textContent = 'Registry entry added successfully!';
        form.insertBefore(successMessage, form.firstChild);
 
        if (!toggleButton.classList.contains('active')) {
          toggleButton.classList.add('active');
          registryDisplay.style.display = 'block';
        }
 
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
      } catch (error) {
        const errorMessage = document.createElement('div');
        errorMessage.className = 'form-message form-message--error';
        errorMessage.textContent = 'Failed to save registry entry. Please try again.';
        form.insertBefore(errorMessage, form.firstChild);
 
        setTimeout(() => {
          errorMessage.remove();
        }, 5000);
      } finally {
        submitButton.disabled = false;
        submitButton.classList.remove('button-loading');
        submitButton.textContent = originalText;
      }
 
      console.log('Current Registry Data:', registryData);
    });
 
    toggleButton.addEventListener('click', async function (e) {
      e.preventDefault();
      this.classList.toggle('active');
      
      if (this.classList.contains('active')) {
        try {
          const data = await fetchRegistryData(customerId);
          registryData = data;
          updateRegistryDisplay(registryData);
          registryDisplay.style.display = 'block';

          applyDateMaxToEditInputs();

        } catch (error) {
          console.error('Error fetching registry data:', error);
          const errorMessage = document.createElement('div');
          errorMessage.className = 'form-message form-message--error';
          errorMessage.textContent = 'Failed to fetch registry entries. Please try again.';
          form.insertBefore(errorMessage, form.firstChild);
 
          setTimeout(() => {
            errorMessage.remove();
          }, 5000);
        }
      } else {
        registryDisplay.style.display = 'none';
      }
    });
 
    registryDisplay.style.display = 'none';
 
    registryEntries.addEventListener('click', async function(e) {
      const deleteButton = e.target.closest('.delete-entry-button');
      const editButton = e.target.closest('.edit-entry-button');
      const saveButton = e.target.closest('.save-button');
      const cancelButton = e.target.closest('.cancel-button');
      const overlay = e.target.closest('.edit-form-popup-overlay');
      
      if (deleteButton) {
        const entryElement = deleteButton.closest('.registry-entry');
        const entryIndex = Array.from(document.querySelectorAll('.registry-entry')).indexOf(entryElement);
 
        deleteButton.disabled = true;
        deleteButton.classList.add('button-loading');
 
        try {
          registryData.splice(entryIndex, 1);
 
          const payload = {
            customerId: customerId,
            childDetails: registryData,
          };
 
          await sendToAPI(payload);
 
          const updatedData = await fetchRegistryData(customerId);
          registryData = updatedData;
          updateRegistryDisplay(registryData);

          applyDateMaxToEditInputs();
 
          const successMessage = document.createElement('div');
          successMessage.className = 'form-message form-message--success';
          successMessage.textContent = 'Registry entry deleted successfully!';
          form.insertBefore(successMessage, form.firstChild);
 
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        } catch (error) {
          const errorMessage = document.createElement('div');
          errorMessage.className = 'form-message form-message--error';
          errorMessage.textContent = 'Failed to delete registry entry. Please try again.';
          form.insertBefore(errorMessage, form.firstChild);
 
          deleteButton.disabled = false;
          deleteButton.classList.remove('button-loading');
 
          setTimeout(() => {
            errorMessage.remove();
          }, 5000);
        }
      } else if (editButton) {
        const entryElement = editButton.closest('.registry-entry');
        const currentGender = entryElement.querySelector('.entry-gender').textContent.trim();
        const overlay = entryElement.querySelector('.edit-form-popup-overlay');
        const editForm = entryElement.querySelector('.edit-form');
        
        entryElement.querySelector('.edit-name').value = entryElement.querySelector('.entry-name').textContent.trim();
        const dateValue = entryElement.querySelector('.entry-age').dataset.date;
        entryElement.querySelector('.edit-age').value = dateValue ? new Date(dateValue).toISOString().split('T')[0] : '';
        
        const genderInputs = entryElement.querySelectorAll('input[name^="edit-gender"]');
        genderInputs.forEach(input => {
          input.checked = input.value === currentGender;
        });

        applyDateMaxToEditInputs();
        
        overlay.classList.add('active');
        editForm.classList.add('active');
        document.body.style.overflow = 'hidden';
      } else if (saveButton) {
        const entryElement = saveButton.closest('.registry-entry');
        const entryIndex = parseInt(entryElement.dataset.entryIndex);
 
        const newName = entryElement.querySelector('.edit-name').value.trim();
        const newAge = entryElement.querySelector('.edit-age').value;
        const newGender = entryElement.querySelector('input[name^="edit-gender"]:checked').value;
 
        if (!newName || !newAge || !newGender) {
          const errorMessage = document.createElement('div');
          errorMessage.className = 'form-message form-message--error';
          errorMessage.textContent = 'Please fill in all fields.';
          form.insertBefore(errorMessage, form.firstChild);
 
          setTimeout(() => {
            errorMessage.remove();
          }, 3000);
          return;
        }

        const maxDateEdit = todayISOLocal();
        if (newAge > maxDateEdit) {
          saveButton.disabled = false;
          saveButton.classList.remove('button-loading');
          saveButton.textContent = 'Save Changes';

          const errorMessage = document.createElement('div');
          errorMessage.className = 'form-message form-message--error';
          errorMessage.textContent = 'Birth date cannot be in the future.';
          form.insertBefore(errorMessage, form.firstChild);
          setTimeout(() => errorMessage.remove(), 4000);
          return;
        }
 
        saveButton.disabled = true;
        saveButton.classList.add('button-loading');
        saveButton.textContent = 'Saving...';
 
        try {
          registryData[entryIndex] = {
            name: newName,
            age: newAge,
            gender: newGender
          };
 
          const payload = {
            customerId: customerId,
            childDetails: registryData,
          };
 
          await sendToAPI(payload);
 
          const updatedData = await fetchRegistryData(customerId);
          registryData = updatedData;
          updateRegistryDisplay(registryData);

          applyDateMaxToEditInputs();
 
          const overlay = entryElement.querySelector('.edit-form-popup-overlay');
          const editForm = entryElement.querySelector('.edit-form');
          overlay.classList.remove('active');
          editForm.classList.remove('active');
          document.body.style.overflow = '';
 
          const successMessage = document.createElement('div');
          successMessage.className = 'form-message form-message--success';
          successMessage.textContent = 'Registry entry updated successfully!';
          form.insertBefore(successMessage, form.firstChild);
 
          setTimeout(() => {
            successMessage.remove();
          }, 3000);
        } catch (error) {
          const errorMessage = document.createElement('div');
          errorMessage.className = 'form-message form-message--error';
          errorMessage.textContent = 'Failed to update registry entry. Please try again.';
          form.insertBefore(errorMessage, form.firstChild);
 
          setTimeout(() => {
            errorMessage.remove();
          }, 5000);
        } finally {
          saveButton.disabled = false;
          saveButton.classList.remove('button-loading');
          saveButton.textContent = 'Save Changes';
        }
      } else if (cancelButton || (overlay && e.target === overlay)) {
        const entryElement = (cancelButton || overlay).closest('.registry-entry');
        const overlayEl = entryElement.querySelector('.edit-form-popup-overlay');
        const editForm = entryElement.querySelector('.edit-form');
        
        overlayEl.classList.remove('active');
        editForm.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundles-of-joy-promo"] && !Shopify.designMode) return;
  try {
     
  document.addEventListener("DOMContentLoaded", function() {
    const carousel = document.querySelector('.flickity-carousel');
    let flkty;

    function initCarousel() {
      const isMobile = window.innerWidth < 768;
      const totalSlides = carousel ? carousel.querySelectorAll('.carousel-cell').length : 0;
      const visibleSlides = isMobile ? 1 : 3; // On mobile: 1 slide visible, on desktop: 3 slides visible
      const showPagination = totalSlides > visibleSlides;
      
      if (isMobile) {
        if (!flkty && carousel) {
          flkty = new Flickity(carousel, {
            cellAlign: 'left',
            contain: true,
            pageDots: showPagination,
            prevNextButtons: false,
            wrapAround: false,
            groupCells: false,
            setGallerySize: true,
            imagesLoaded: true,
            percentPosition: false
          });
        }
      } else {
        if (!flkty && carousel) {
          flkty = new Flickity(carousel, {
            cellAlign: 'left',
            contain: true,
            pageDots: showPagination,
            prevNextButtons: false,
            wrapAround: true,
            groupCells: '100%',
            setGallerySize: true,
            imagesLoaded: true,
            percentPosition: false,
            freeScroll: false,
            autoPlay: false,
            cellSelector: '.carousel-cell'
          });
        }
      }
    }
    
    setTimeout(function() {
      initCarousel();
    }, 100);
    
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (flkty) {
          flkty.destroy();
          flkty = null;
        }
        initCarousel();
      }, 250);
    });
  });
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-info"] && !Shopify.designMode) return;
  try {
     
  function applyTextTruncation() {
    document.querySelectorAll('.customer-info__top-text').forEach(function(topText) {
      var contentSpan = topText.querySelector('.customer-info__top-text-content');
      var button = topText.querySelector('.read_more');
      if (!contentSpan || !button) return;

      if (!contentSpan.dataset.originalHtml) {
        contentSpan.dataset.originalHtml = contentSpan.innerHTML;
        contentSpan.dataset.plainText = contentSpan.textContent.trim();
      }

      var originalHTML = contentSpan.dataset.originalHtml;
      var plainText = contentSpan.dataset.plainText;

      var limit = window.innerWidth <= 767 ? 150 : 400;

      if (plainText.length > limit) {
        var truncated = plainText.slice(0, limit) + '...';
        if (button.textContent === 'Read less') {
          contentSpan.innerHTML = originalHTML;
          contentSpan.appendChild(button);
        } else {
          contentSpan.innerHTML = truncated;
          contentSpan.appendChild(button);
        }
        button.style.display = 'inline-block';
        button.textContent = 'Read more';

        button.onclick = function() {
          if (button.textContent === 'Read more') {
            contentSpan.innerHTML = originalHTML;
            button.textContent = 'Read less';
            contentSpan.appendChild(button);
          } else {
            contentSpan.innerHTML = truncated;
            button.textContent = 'Read more';
            contentSpan.appendChild(button);
          }
        };
      } else {
        contentSpan.innerHTML = plainText;
        button.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', applyTextTruncation);
  window.addEventListener('resize', applyTextTruncation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frequently-bought-together"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    // Wait a bit for the page to fully load
    setTimeout(() => {
      initializeFBT();
    }, 100);
  });

  function initializeFBT() {
    const checkboxes = document.querySelectorAll(".fbt-checkbox");
    const totalEl = document.getElementById("fbt-total");
    const addAllBtn = document.getElementById("fbt-add-all");

    if (!addAllBtn) {
      return;
    }

    if (checkboxes.length === 0) {
      return;
    }

    function updateTotal() {
      let total = 0;
      
      checkboxes.forEach((cb, index) => {
        if (cb.checked) {
          const price = parseFloat(cb.dataset.price);
          if (!isNaN(price)) {
            total += price;
          }
        }
      });
      
      if (totalEl) {
        totalEl.textContent = new Intl.NumberFormat("en-IN").format(total);
      }
    }

    // Initial load
    console.log("FBT: Running initial total calculation");
    updateTotal();

    // Update on change
    checkboxes.forEach((cb, index) => {
      cb.addEventListener("change", function() {
        updateTotal();
      });
    });

    // Add all to cart - SIMPLE VERSION
    addAllBtn.addEventListener("click", function () {
      const button = this;
      const originalText = button.textContent;
      
      // Show loading state
      button.textContent = "Adding to cart...";
      button.disabled = true;
      
      let items = [];
      checkboxes.forEach((cb, index) => {
        if (cb.checked) {
          const variantId = cb.dataset.variantId;
          if (variantId && variantId !== 'undefined' && variantId !== 'null') {
            items.push({
              id: variantId,
              quantity: 1
            });
          }
        }
      });

      if (items.length === 0) {
        button.textContent = "No items selected";
        button.disabled = false;
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
        return;
      }

      // SIMPLE APPROACH: Add items one by one
      
      let addedCount = 0;
      let totalItems = items.length;
      
      function addNextItem(index) {
        if (index >= totalItems) {
          // All items added successfully
          button.textContent = "Added to cart!";
          button.style.background = "#28a745";
          
          // Try to open cart drawer
          
          // Method 1: Trigger cart refresh event with open flag
          document.dispatchEvent(new CustomEvent('cart:refresh', { 
            detail: { open: true } 
          }));
          
          // Method 2: Also try to open the drawer directly after a short delay
          setTimeout(() => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.openMenuDrawer === 'function') {
              cartDrawer.openMenuDrawer();
            }
          }, 300);
          
          // Method 3: Try to find mini-cart element and trigger it
          setTimeout(() => {
            const miniCart = document.querySelector('mini-cart');
            if (miniCart && typeof miniCart.open === 'function') {
              miniCart.open();
            }
          }, 600);
          
          // Method 4: Check if drawer opened very quickly (immediate check)
          setTimeout(() => {
            if (checkDrawerStatus()) {
              drawerOpened = true;
            }
          }, 100);
          
          // Check if cart drawer opened successfully and prevent redirect if it did
          let drawerOpened = false;
          
          // Method 1: Check for cart drawer open class
          const checkDrawerStatus = () => {
            const cartDrawer = document.querySelector('cart-drawer');
            const isDrawerOpen = cartDrawer && cartDrawer.classList.contains('mini-cart--open');
            
            // Also check for other possible open indicators
            const isDetailsOpen = cartDrawer && cartDrawer.querySelector('details[open]');
            const hasOpenAttribute = cartDrawer && cartDrawer.hasAttribute('open');
            const isVisible = cartDrawer && cartDrawer.offsetWidth > 0 && cartDrawer.offsetHeight > 0;
            
            if (isDrawerOpen || isDetailsOpen || hasOpenAttribute || isVisible) {
              drawerOpened = true;
              return true;
            }
            return false;
          };
          
          // Check immediately
          if (checkDrawerStatus()) {
            drawerOpened = true;
          }
          
          // Check again after a short delay
          setTimeout(() => {
            if (checkDrawerStatus()) {
              drawerOpened = true;
            }
          }, 500);
          
          // Final check and fallback only if drawer never opened
          setTimeout(() => {
            if (!drawerOpened) {
              window.location.href = '/cart';
            }
          }, 1500);
          
          // Reset button after a delay
          setTimeout(() => {
            button.textContent = originalText;
            button.style.background = "";
            button.disabled = false;
          }, 3000);
          return;
        }
        
        const item = items[index];
        
        // Validate item data
        if (!item.id || item.id === 'undefined' || item.id === 'null') {
          button.textContent = "Error - Invalid product data";
          button.disabled = false;
          return;
        }
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.id,
            quantity: item.quantity
          })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status) {
            // Error adding this item
            button.textContent = "Error - Try again";
            button.disabled = false;
            return;
          }
          
          // Success - add next item
          addedCount++;
          addNextItem(index + 1);
        })
        .catch(error => {
          button.textContent = "Error - Try again";
          button.disabled = false;
        });
      }
      
      // Start adding items
      addNextItem(0);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
